import { api } from '../../core/api/queries';
import { DOCUMENT_LINKS } from '../../constants/config';

/**
 * Linkurile celor patru documente ale editiei curente (SE-14): protocol de colaborare,
 * regulament, mecanism, prezentare colaboratori — publice, functioneaza si fara login
 * (acord parental, confirmare inscriere).
 *
 * 🔴 FARA FLICKER: fallback-ul (`DOCUMENT_LINKS`, valorile de azi) se randeaza INSTANT, din
 * prima randare — nu exista stare „se incarca" intre goale/spinner si link. Cand raspunsul
 * backendului soseste, fiecare cheie se inlocuieste DOAR daca serverul a trimis o valoare
 * nevida; o cerere esuata sau o cheie lipsa lasa fallback-ul neatins. Azi cele doua seturi
 * sunt identice (backendul are acelasi fallback intern), deci schimbarea vizuala e de obicei
 * zero — comportamentul conteaza abia cand ECOTIC schimba un document (SP-07).
 */
export function useEditionDocuments() {
    const { data } = api.editions.documents.useQuery();

    return {
        protocolColaborare: data?.protocolColaborare || DOCUMENT_LINKS.PROTOCOL_COLABORARE,
        regulament: data?.regulament || DOCUMENT_LINKS.REGULAMENT,
        mecanism: data?.mecanism || DOCUMENT_LINKS.MECANISM,
        colaboratori: data?.colaboratori || DOCUMENT_LINKS.COLABORATORI,
    };
}
